const insertAfter = (element: HTMLElement, after: Element): HTMLElement => {
    const parent = after.parentNode
    if (!parent) {
        return element
    }
    parent.insertBefore(element, after.nextElementSibling)
    return element
}

const insertAsLastChild = (
    element: HTMLElement,
    append: ParentNode,
): HTMLElement => {
    append.appendChild(element)
    return element
}

type InsertDomElementOptions = {
    el?: string
    attr?: Record<string, string>
    after?: Element | null
    append?: ParentNode
}

/**
 * Insert an element to the DOM.
 * @return the inserted element
 */
export default function insertDomElement({
    el = 'div',
    attr = {},
    after = undefined,
    append = document.body, // defaults to appending to body
}: InsertDomElementOptions = {}): HTMLElement {
    const element = document.createElement(el)

    for (const a in attr) {
        element.setAttribute(a, attr[a])
    }

    if (after != null) {
        return insertAfter(element, after)
    }
    return insertAsLastChild(element, append)
}
